
import { BizTab } from '../types';

interface StickyCTAProps {
  /** 当前激活的业务标签 */
  activeTab: BizTab;
  /** 打开抽屉的回调，参数为可选的说明文字 */
  onOpenDrawer: (note?: string) => void;
}

/**
 * 根据不同业务标签展示对应的起步价。
 * 若传入的 `activeTab` 不在 `priceMap` 中，则返回 “暂无报价”，防止运行时出现 undefined。
 */
const priceMap: Record<BizTab, string> = {
  '9810': '4,000元/年起',
  '0110': '8,000元/年起',
  '1039': '22,800元/年起',
  'A': '9.9元起',
};

export default function StickyCTA({ activeTab, onOpenDrawer }: StickyCTAProps) {
  // 安全获取报价，若未匹配到则使用兜底文案
  const price = priceMap[activeTab] ?? '暂无报价';

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-2xl z-30">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-sm text-gray-500">推荐起步价</p>
          <p className="text-xl font-bold text-gray-800">{price}</p>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={() => onOpenDrawer('我想先跑通一票，了解A类工具')}
            className="px-6 py-3 bg-gray-100 text-gray-700 font-medium rounded-full hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer"
          >
            先跑通一票
          </button>
          <button
            onClick={() => onOpenDrawer()}
            className="px-6 py-3 bg-white border-2 border-[#14B8A6] text-[#14B8A6] font-medium rounded-full hover:bg-[#14B8A6] hover:text-white transition-all whitespace-nowrap cursor-pointer"
          >
            咨询报价
          </button>
          <button
            onClick={() => onOpenDrawer('我想立即订阅')}
            className="px-8 py-3 bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] text-white font-medium rounded-full hover:scale-105 transition-transform whitespace-nowrap cursor-pointer"
          >
            立即订阅
          </button>
        </div>
      </div>
    </div>
  );
}
